"use client"

import { WishlistIcon } from "src/components/icons"
import { HeaderLink } from "src/components/layout/header/HeaderLink"
import { HeaderLinkBadge } from "src/components/layout/header/HeaderLinkBadge"
import { useWishlistCount } from "src/components/wishlist/state"
import { wishlistText } from "src/components/wishlist/text"
import { routes } from "src/config/routes"
import { localizeText } from "src/localization/utils"

export const HeaderWishlistLink = () => {
  const T = localizeText(wishlistText)
  const count = useWishlistCount()

  return (
    <HeaderLink href={routes.wishlist} label={T.title}>
      <WishlistIcon size={24} />
      <HeaderLinkBadge value={count} />
    </HeaderLink>
  )
}
